import React from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
  Button,
  Collapse,
  TableBody,
  ListItemButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function PlatformDropdown({platforms, selected, onSelect}) {
        const [open, setOpen] = React.useState(false);

        return (
            <>
                <Button className="table_cell" size="small" onClick={() => setOpen(!open)}>
                   {selected?.name} + {platforms.length-1} Platforms
                </Button>

                <Collapse in={open}>
                    <List dense>
                        {platforms.map((platform, index) => (
                            <ListItem key={index} disabledPadding>
                                <ListItemButton selected={selected?.name === platform.name}
                                onClick={() => {
                                    onSelect(platform);
                                    setOpen(false);
                                }}>
                                    <ListItemText primary={platform.name} />
                                </ListItemButton> 
                            </ListItem>
                        ))}
                    </List>
                </Collapse>
            </>
        );
}


function AdTypesDropdown({adTypes}) {
        const [open, setOpen] = React.useState(false);

        return (
            <>
                <Button className="table_cell" size="small" onClick={() => setOpen(!open)}>
                    {adTypes.length} Ad Types
                </Button>

                <Collapse in={open}>
                    <List dense>
                        {adTypes.map((type, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={type} />
                            </ListItem>
                        ))}
                    </List>
                </Collapse>
            </>
        );
}

class Platforms extends React.Component {

    state = {
        selectedPlatforms: {}
    };

    handleSelectPlatform = (category, platform) => {
        this.setState(prev => ({
            selectedPlatforms: {
                ...prev.selectedPlatforms,
                [category]: platform
            }
        }));
    };

    groupedByPlatforms = [
        {
            category: "Default",
            platforms: [
                {
                    name: "Facebook",
                    adTypes: [
                        "FB Feed Image",
                        "FB Feed Video",
                        "FB Feed Ads - image",
                        "FB Feed Ads - video",
                        "FB Story Content",
                        "FB Story Ads - image",
                        "FB Story Ads - video",
                        "FB Story Ads - Carousel",
                        "FB Watch Feed",
                        "FB Watch Feed instream video",
                    ],
                },
                {
                    name:"Instagram",
                    adTypes: [
                        "IG Feed - image",
                        "IG Feed - video",
                        "IG Story - image",
                        "IG Story - video",
                        "IG Shopping - 1 image in feed. Carousel when opened"
                    ],
                },
                {
                    name:"Pinterest",
                    adTypes: [
                        "Pinterest - Static Image",
                        "Pinterest Video",
                        "Pinterest Full Width Video",
                        "Pinterest Carousel Ad",
                    ],
                },
                {
                    name:"Twitter",
                    adTypes: [
                        "TW Text ad - max 280 characters",
                        "TW Single Image",
                        "TW Single Video - no time limit but 15sec recommended",
                        "TW Image carousel",
                        "TW Video carousel",
                    ],
                },
                {
                    name:"Xiao",
                    adTypes: [
                    
                    ]
                },
                {
                    name:"Trainline",
                    adTypes: [
                        "Static Image"
                    ]
                },

            ]
        },
        {
            category: "Reel",         
            platforms: [
                {
                    name:"TikTok",
                    adTypes: [
                        "TT InFeed Ads - 5-60sec",
                        "TT topview ads - 5-60sec",
                    ]
                },
                {
                    name: "Snapchat",
                    adTypes: [
                        "SC Story - Single image",
                        "SC Story - Single video",
                        
                    ],
                },
                {
                    name:"Douyin",
                    adTypes: [
                        "Feed Ads - video",
                        "Feed Ads - image"
                    ]
                },

            ]
        }, 
        {
            category: "Gmail",
            platforms: [
                {
                    name:"Gmail",
                    adTypes: [
                        "TC preroll - 30sec - non skipable",
                        "TC midroll - 30sec - non skipable",
                    ]
                },
            ]
        },
        {
            category: "Video",         
            platforms: [
                {
                    name:"Youtube",
                    adTypes: [
                        "YT Basic Content",
                        "YT skippable - skip after 5s",
                        "YT non-skippable - 15-20s",
                        "YT bumper - 6 seconds",
                        "YT overlay - banner",
                        "YT Standard Display - top right",
                        "YT Masthead - Desktop",
                        "YT Masthead - Mobile"
                    ],
                },
                {
                    name:"Twitch",
                    adTypes: [
                        "TC preroll - 30sec - non skipable",
                        "TC midroll - 30sec - non skipable",
                    ],
                },
            ] 
        },        
        {
            category: "Streamer",
            platforms: [
                {
                    name:"VideoLand",
                    adTypes: [
                        "Preroll"
                    ]
                },
                {
                    name:"ITVx",
                    adTypes: [
                        "Preroll"
                    ]
                },
                {
                    name:"Tencent",
                    adTypes: [
                        
                    ]
                },
                {
                    name:"IQIYI",
                    adTypes: [
                        
                    ]
                },
                {
                    name:"Netflix",
                    adTypes: [
                        "Preroll"
                    ]
                },
                {
                    name:"Amazon Prime",
                    adTypes: [
                        "Preroll"
                    ]
                },
                {
                    name:"Disney+",
                    adTypes: [
                        "Preroll"
                    ]
                },
                {
                    name:"Vidaa",
                    adTypes: [
                        "Preroll"
                    ]
                },
            ]
        },
        {
            category: "Article",
            platforms: [
                {
                    name:"The Guardian",
                    adTypes: [
                        "Digital Ad placements"
                    ]
                },
                {
                    name:"Apple News",
                    adTypes: [
                        "Digital Ad placements"
                    ]
                },
                {
                    name:"Daily Mail",
                    adTypes: [
                        "Digital Ad placements"
                    ]
                },
            ]
        },
        {
            category: "Music",
            platforms: [
                {
                    name:"Amazon Music Player (Music, Radio, Podcasts)",
                    adTypes: [
                        "Audio Pre, mid or post roll"
                    ]
                },
            ]
        },  

    ];

    handleViewCategory = (category) => {
        this.props.toPersona(category);
    };


    render() {
        return (
           <Box className="ad-types-page" sx={{p:2}} style={{width: "90%", margin: "0 auto"}}>
                <Typography variant="h5" gutterBottom style={{display: 'flex', justifyContent: 'space-around', margin: '1rem'}}>
                   <span>AD TYPES BY PLATFORM</span>  
                   
                </Typography>
                
                <TableContainer component={Paper} className="table_container" style={{maxHeight: "80vh"}}>
                    <Table>
                        <TableHead className="table_head">
                            <TableRow>
                                <TableCell className="table_cell top_row" style={{fontWeight: "600", width: "10%"}}>Category</TableCell>
                                <TableCell className="table_cell top_row" style={{fontWeight: "600", width: "30%"}}>Platform</TableCell>
                                <TableCell className="table_cell top_row" style={{fontWeight: "600", width: "15%"}}>Ad Types</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {this.groupedByPlatforms.map((group, index) => {
                                    const isDark = index % 2 === 0;
                                    const selectedPlatform = this.state.selectedPlatforms[group.category] ?? group.platforms[0];
                                  
                                    return (
                                    <TableRow key={group.category} 
                                    className={`table_row ${isDark ? 'dark_row' : 'light_row'}` }>

                                        {/*category  */}
                                        <TableCell className="table_cell" >
                                            <Box display="flex" flexDirection="column" gap={1} >
                                                <strong>{group.category}</strong>
                                                <Button size="small" variant="contained"
                                                    onClick={() =>
                                                        this.handleViewCategory(group.category)
                                                    }>
                                                        View {group.category}
                                                    </Button>
                                            </Box>
                                        </TableCell>

                                        {/* Platform dropdown */}
                                        <TableCell className="table_cell">
                                            <PlatformDropdown platforms={group.platforms} selected={selectedPlatform}
                                                onSelect={(platform) => this.handleSelectPlatform(group.category, platform)} />
                                        </TableCell>

                                        {/* AdTypes dropdown */}
                                        <TableCell className="table_cell">
                                            {selectedPlatform && (
                                                <AdTypesDropdown adTypes={selectedPlatform.adTypes} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }
}

function PlatformsWithNavigation(props) {
    const navigate = useNavigate();

    const toPersona = (data) => {
        navigate("/new-personas", {state: {group: data},
        })
    }

    return <Platforms {...props} toPersona={toPersona} />
}

export default PlatformsWithNavigation;